import { TextDataMaterial } from 'features/assetViz/materials/TextDataMaterial'
import { useSurfaceProps } from 'features/assetViz/objects/surfaces/util/SurfaceProvider'
import { RenderOrder } from 'features/assetViz/utils/renderingDefines'
import React from 'react'
import { ComponentSurfaceWrappingMode, GeckoComponentDataFrame } from 'types'

/**
 * A layer used to render a grid on a component's surface
 * @param index                   An optional index used to name this chunk
 * @param cdf                     The current CDF being rendered
 * @constructor
 */
export const TextDataLayerChunk3D: React.FC<{
  cdf: GeckoComponentDataFrame
}> = ({ cdf }) => {
  //----------------------------------------------------------------------------

  const { bounds, geometry, wrapMode } = useSurfaceProps()

  return (
    <mesh
      name={`${bounds.componentID}_text_data_chunk`}
      geometry={geometry}
      renderOrder={RenderOrder.TextLayer}>
      <TextDataMaterial
        chunkBounds={bounds}
        doWrapX={wrapMode === ComponentSurfaceWrappingMode.ComponentWrapsX}
        doWrapY={wrapMode === ComponentSurfaceWrappingMode.ComponentWrapsY}
        cdf={cdf}
      />
    </mesh>
  )
}
